import React, { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import { server, files } from "../configs";
import { Context } from "../GlobalContext";
import Axios from "axios";
import Swal from "sweetalert2";
import "../global/pages.css";
import "./Info.css";

const InfoOne = ({ history }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [dongList, setDongList] = useState([]);
  const [gradeList, setGradeList] = useState([]);
  const [dongId, setDongId] = useState(0);
  const [gender, setGender] = useState("");
  const [year, setYear] = useState(0);
  const [grade, setGrade] = useState("");
  const [liveWith, setLiveWith] = useState([]);
  const [myChildLiveWith, setMyChildLiveWith] = useState([]);
  const [relationWithChild, setRelationWithChild] = useState("");
  const [achievement, setAchievement] = useState("");
  const [jobType, setJobType] = useState("");
  const [certificate, setCertificate] = useState([]);
  const [isEducated, setIsEducated] = useState(null);
  const [workedAt, setWorkedAt] = useState("");
  const {
    token,
    userData,
    selfData,
    setSelfData,
    reqInfoPages,
    firstSurvType,
  } = useContext(Context);

  const fieldsList = userData.requiredInfo;

  const startYear = 1900;
  const endYear = new Date().getFullYear();
  const yearList = [...Array(endYear + 1 - startYear).keys()].map(
    (a) => endYear - a
  );
  let keyCnt = 1;
  const genderList = ["여자", "남자"];
  const familyList = [
    "어머니",
    "아버지",
    "할아버지",
    "할머니",
    "형제자매",
    "기타 보호자",
  ];
  const educList = [
    "대학원 이상",
    "대학교 졸업",
    "전문대학 졸업",
    "고등학교 졸업",
    "중학교 졸업",
    "초등학교 졸업",
  ];
  const jobList = [
    "전일제 직업\n(정규직, 계약직 포함)",
    "시간제 직업",
    "전업주부",
    "자영업, 프리랜서",
    "무직",
    "기타",
  ];
  const certificateList = [
    "사회복지사",
    "보육교사, 유치원교사",
    "상담심리관련 자격",
    "청소년관련 자격\n(청소년 지도사/상담사)",
    "초등 및 중등 교사",
    "재활치료 및 간호 관련 자격",
    "기타",
  ];
  const isEducatedList = [
    { bool: true, str: "예" },
    { bool: false, str: "아니오" },
  ];
  const workedAtList = [
    "어린이집",
    "유치원",
    "초등학교",
    "중학교",
    "고등학교",
    "아동청소년관련시설",
  ];

  console.log(userData);

  useEffect(() => {
    if (fieldsList.includes("gradeAsChild")) {
      setGradeList(["초등학교", "중학교", "고등학교", "다니지 않는다"]);
    } else if (fieldsList.includes("gradeAsParent")) {
      setGradeList([
        "어린이집",
        "유치원",
        "초등학교",
        "중학교",
        "고등학교",
        "다니지 않는다",
      ]);
    }
    // if (fieldsList.includes("gradeAsElem")) {
    //   setGradeList(["초등학교 4학년", "초등학교 5학년", "초등학교 6학년"]);
    // } else if (fieldsList.includes("gradeAsMidHigh")) {
    //   setGradeList([
    //     "중학교 1학년",
    //     "중학교 2학년",
    //     "중학교 3학년",
    //     "고등학교 1학년",
    //     "고등학교 2학년",
    //     "고등학교 3학년",
    //   ]);
    // }
    setDongList(userData.gov.dongs);

    const saved = JSON.parse(localStorage.getItem("info"));
    if (saved) {
      setGender(saved.gender);
      setYear(saved.year);
      setGrade(saved.grade);
      setDongId(saved.dongId);
      setLiveWith([...saved.liveWith]);
      setMyChildLiveWith([...saved.myChildLiveWith]);
      setRelationWithChild(saved.relationWithChild);
      setAchievement(saved.achievement);
      setJobType(saved.jobType);
      setCertificate(saved.certificate);
      setIsEducated(saved.isEducated);
      setWorkedAt(saved.workedAt);
    } else {
      setGender(selfData.gender ? selfData.gender : "");
      setYear(selfData.year ? parseInt(selfData.year) : 0);
      setGrade(selfData.grade ? selfData.grade : "");
      setDongId(selfData.dong ? parseInt(selfData.dong.id) : 0);
      setLiveWith(selfData.liveWith ? selfData.liveWith : []);
      setMyChildLiveWith(
        selfData.myChildLiveWith ? selfData.myChildLiveWith : []
      );
      setRelationWithChild(selfData.relation ? selfData.relation : "");
      setAchievement(selfData.achievement ? selfData.achievement : "");
      setJobType(selfData.jobType ? selfData.jobType : "");
      setCertificate(selfData.certificate ? selfData.certificate : []);
      setIsEducated(selfData.isEducated !== null ? selfData.isEducated : null);
      setWorkedAt(selfData.workedAt ? selfData.workedAt : "");
    }

    setIsLoaded(true);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const submit = () => {
    if (
      (gender !== "" ||
        fieldsList.findIndex((field) => field.includes("gender")) === -1) &&
      (year !== 0 ||
        fieldsList.findIndex((field) => field.includes("year")) === -1) &&
      (grade !== "" ||
        fieldsList.findIndex((field) => field.includes("grade")) === -1) &&
      (dongId !== 0 ||
        fieldsList.findIndex((field) => field.includes("dong")) === -1) &&
      (liveWith.length !== 0 ||
        fieldsList.findIndex((field) => field.includes("liveWith")) === -1) &&
      (myChildLiveWith.length !== 0 ||
        fieldsList.findIndex((field) => field.includes("myChildLiveWith")) ===
          -1) &&
      (relationWithChild.length !== 0 ||
        fieldsList.findIndex((field) => field.includes("relationWithChild")) ===
          -1) &&
      (achievement.length !== 0 || !fieldsList.includes("achievement")) &&
      (jobType.length !== 0 || !fieldsList.includes("jobType")) &&
      (certificate.length !== 0 || !fieldsList.includes("certificate")) &&
      (isEducated !== null || !fieldsList.includes("isEducated")) &&
      (workedAt.length !== 0 || !fieldsList.includes("workedAt"))
    ) {
      const jwt = localStorage.getItem("jwt");
      Axios.patch(
        server + "/user/users/me",
        {
          gender:
            fieldsList.findIndex((field) => field.includes("gender")) >= 0
              ? gender.substr(0, 2)
              : null,
          year:
            fieldsList.findIndex((field) => field.includes("year")) >= 0
              ? year
              : null,
          grade:
            fieldsList.findIndex((field) => field.includes("grade")) >= 0
              ? String(grade)
              : null,
          dongId:
            fieldsList.findIndex((field) => field.includes("dong")) >= 0
              ? dongId
              : null,
          liveWith:
            fieldsList.findIndex((field) => field.includes("liveWith")) >= 0
              ? liveWith
              : null,
          myChildLiveWith:
            fieldsList.findIndex((field) =>
              field.includes("myChildLiveWith")
            ) >= 0
              ? myChildLiveWith
              : null,
          relation: fieldsList.includes("relationWithChild")
            ? relationWithChild
            : null,
          achievement: fieldsList.includes("achievement") ? achievement : null,
          jobType: fieldsList.includes("jobType") ? jobType : null,
          certificate: fieldsList.includes("certificate") ? certificate : null,
          isEducated: fieldsList.includes("isEducated") ? isEducated : null,
          workedAt: fieldsList.includes("workedAt") ? workedAt : null,
        },
        {
          headers: { authorization: jwt },
        }
      )
        .then(() => {
          // Remove data that's on the server from localStorage to separate
          // how data is managed
          localStorage.removeItem("info");

          setSelfData({
            ...selfData,
            gender:
              fieldsList.findIndex((field) => field.includes("gender")) >= 0
                ? gender.substr(0, 2)
                : null,
            year:
              fieldsList.findIndex((field) => field.includes("year")) >= 0
                ? year
                : null,
            grade:
              fieldsList.findIndex((field) => field.includes("grade")) >= 0
                ? String(grade)
                : null,
            dong:
              fieldsList.findIndex((field) => field.includes("dong")) >= 0
                ? { id: dongId }
                : null,
            liveWith:
              fieldsList.findIndex((field) => field.includes("liveWith")) >= 0
                ? liveWith
                : null,
            myChildLiveWith:
              fieldsList.findIndex((field) =>
                field.includes("myChildLiveWith")
              ) >= 0
                ? myChildLiveWith
                : null,
            relation: fieldsList.includes("relationWithChild")
              ? relationWithChild
              : null,
            achievement: fieldsList.includes("achievement")
              ? achievement
              : null,
            jobType: fieldsList.includes("jobType") ? jobType : null,
            certificate: fieldsList.includes("certificate")
              ? certificate
              : null,
            isEducated: fieldsList.includes("isEducated") ? isEducated : null,
            workedAt: fieldsList.includes("workedAt") ? workedAt : null,
          });

          const nextPage = reqInfoPages.needsInfoTwo
            ? `/token/${token}/info-2`
            : `/token/${token}/intro/${firstSurvType}/0/0/0`; // Depending on which survey comes first, set surveyType of a/b/c
          history.push(nextPage);
        })
        .catch((e) => {
          console.log(e);
          history.push("/noToken");
        });
    } else {
      const listMsg =
        (gender !== "" ||
        fieldsList.findIndex((field) => field.includes("gender")) === -1
          ? ""
          : "성별, ") +
        (year !== 0 ||
        fieldsList.findIndex((field) => field.includes("year")) === -1
          ? ""
          : "출생연도, ") +
        (grade !== "" ||
        fieldsList.findIndex((field) => field.includes("grade")) === -1
          ? ""
          : "학교, 기관, ") +
        (dongId !== 0 ||
        fieldsList.findIndex((field) => field.includes("dong")) === -1
          ? ""
          : "동네, ") +
        (liveWith.length !== 0 ||
        fieldsList.findIndex((field) => field.includes("liveWith")) === -1
          ? ""
          : "함께 사는 사람, ") +
        (myChildLiveWith.length !== 0 ||
        fieldsList.findIndex((field) => field.includes("myChildLiveWith")) ===
          -1
          ? ""
          : "귀하의 자녀가 함께 사는 사람, ") +
        (relationWithChild.length !== 0 ||
        !fieldsList.includes("relationWithChild")
          ? ""
          : "아동과의 관계, ") +
        (achievement !== "" || !fieldsList.includes("achievement")
          ? ""
          : "학력, ") +
        (jobType !== "" || !fieldsList.includes("jobType")
          ? ""
          : "직업 유형, ") +
        (certificate.length !== 0 || !fieldsList.includes("certificate")
          ? ""
          : "보유하신 자격증, ") +
        (isEducated !== null || !fieldsList.includes("isEducated")
          ? ""
          : "아동인권 관련 교육 경험, ") +
        (workedAt !== "" || !fieldsList.includes("workedAt")
          ? ""
          : "종사중인 기관 및 시설의 유형, ");

      Swal.fire({
        title: "확인해 주세요!",
        confirmButtonText: "닫기",
        confirmButtonColor: "#00aeef",
        text: listMsg.substring(0, listMsg.length - 2) + "을(를) 입력해주세요.",
        heightAuto: false,
      });
    }
  };

  useEffect(() => {
    localStorage.setItem(
      "info",
      JSON.stringify({
        gender,
        year,
        grade,
        dongId,
        liveWith,
        myChildLiveWith,
        relationWithChild,
        achievement,
        jobType,
        certificate,
        isEducated,
        workedAt,
      })
    );
  }, [
    gender,
    year,
    grade,
    dongId,
    liveWith,
    myChildLiveWith,
    relationWithChild,
    achievement,
    jobType,
    certificate,
    isEducated,
    workedAt,
  ]);

  return (
    isLoaded && (
      <div className="container" id="info__container">
        <div className="title" id="info__title">
          <div className="icon">
            <img src={files + "/talk.svg"} alt="참여를 위한 기본 정보" />
          </div>
          <h3>참여를 위한 기본 정보</h3>
        </div>
        <div className="content" id="info__content">
          <p>아래는 참가하시는 분에 대한 기본적인 사항을 묻는 질문입니다.</p>
          <div className="info-box">
            {fieldsList.findIndex((field) => field.includes("gender")) >= 0 && (
              <div className="question first-page">
                <b>
                  {fieldsList.includes("genderAsChild")
                    ? "당신의 "
                    : fieldsList.includes("genderAsParent") ||
                      fieldsList.includes("genderAsOfficer")
                    ? "당신의 "
                    : null}
                  성별은 무엇인가요?
                </b>
                <div className="red-dot" />
                <br />
                <div className="radio">
                  {genderList.map((item, idx) => (
                    <div className="info-radio-choice" key={keyCnt++}>
                      <input
                        id={"gender" + idx}
                        type="radio"
                        name="gender"
                        value={idx}
                        onChange={(e) => setGender(genderList[e.target.value])}
                        checked={gender === genderList[idx]}
                      />
                      <label
                        className="gender"
                        htmlFor={"gender" + idx}
                        alt={item}
                      >
                        {item}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {fieldsList.findIndex((field) => field.includes("year")) >= 0 && (
              <div className="question first-page">
                <b>
                  {fieldsList.includes("yearAsChild")
                    ? "당신은 "
                    : fieldsList.includes("yearAsParent") ||
                      fieldsList.includes("yearAsOfficer")
                    ? "당신은 "
                    : null}
                  몇 년도에 태어났나요?
                </b>
                <div className="red-dot" />
                <select
                  name="year"
                  className="drop-down info-year"
                  onChange={(e) => setYear(Number(e.target.value))}
                  value={year}
                >
                  <option value={0} disabled>
                    출생연도 선택하기
                  </option>
                  {yearList.map((year) => (
                    <option key={keyCnt++} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>
            )}
            {fieldsList.findIndex((field) => field.includes("dong")) >= 0 && (
              <div className="question first-page">
                <b>
                  {fieldsList.includes("dongAsChild")
                    ? "당신은 "
                    : fieldsList.includes("dongAsParent")
                    ? "당신은 "
                    : null}
                  현재 어디에 살고 있나요?
                </b>
                <div className="red-dot" />
                <select
                  name="dong"
                  className="drop-down info-dong"
                  onChange={(e) => setDongId(parseInt(e.target.value))}
                  value={dongId}
                >
                  <option value={0} disabled>
                    거주지 선택하기
                  </option>
                  {dongList.map((dong) => (
                    <option key={keyCnt++} value={dong.id}>
                      {dong.name}
                    </option>
                  ))}
                </select>
              </div>
            )}
            {fieldsList.findIndex((field) => field.includes("grade")) >= 0 && (
              <div className="question first-page">
                <b>
                  {fieldsList.includes("genderAsChild")
                    ? "당신은 어느 학교에 다니나요?"
                    : "당신의 자녀는 어느 학교(기관)에 다니나요?"}
                </b>
                <div className="red-dot" />
                <br />
                <div
                  className={`info-grid ${
                    fieldsList.includes("gradeAsElem")
                      ? "info-grid-short"
                      : null
                  }`}
                >
                  {gradeList.map((item, idx) => (
                    <div className="radio" key={keyCnt++}>
                      <input
                        id={"grade" + idx}
                        type="radio"
                        name="grade"
                        value={idx}
                        onChange={(e) => setGrade(gradeList[e.target.value])}
                        checked={grade === gradeList[idx]}
                      />
                      <label
                        className="info-grid-choice"
                        htmlFor={"grade" + idx}
                        alt={item}
                      >
                        {item}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {fieldsList.includes("liveWith") && (
              <div className="question first-page">
                <b>본인은 누구와 함께 살고 있습니까?</b>
                <div className="red-dot" />
                <br />
                <b>(모두 표시해주세요. )</b>
                <div className="info-grid">
                  {familyList.map((item, idx) => (
                    <div className="checkbox" key={keyCnt++}>
                      <input
                        id={"liveWith" + idx}
                        type="checkbox"
                        name="liveWith"
                        value={idx}
                        checked={liveWith.includes(familyList[idx])}
                        onChange={(e) => {
                          // If not in the list, add
                          if (
                            liveWith.indexOf(familyList[e.target.value]) === -1
                          ) {
                            setLiveWith([
                              ...liveWith,
                              familyList[e.target.value],
                            ]);

                            // If in the list, remove
                          } else {
                            const foundIndex = liveWith.indexOf(
                              familyList[e.target.value]
                            );
                            const newLiveWith = liveWith;
                            newLiveWith.splice(foundIndex, 1);
                            setLiveWith([...newLiveWith]);
                          }
                        }}
                      />
                      <label
                        className="info-grid-choice"
                        htmlFor={"liveWith" + idx}
                        alt={item}
                      >
                        {item}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {fieldsList.includes("myChildLiveWith") && (
              <div className="question first-page">
                <b>귀하의 자녀는 누구와 함께 살고 있습니까?</b>
                <div className="red-dot" />
                <br />
                <b>(모두 표시해주세요. )</b>
                <div className="info-grid">
                  {familyList.map((item, idx) => (
                    <div className="checkbox" key={keyCnt++}>
                      <input
                        id={"myChildLiveWith" + idx}
                        type="checkbox"
                        name="myChildLiveWith"
                        value={idx}
                        checked={myChildLiveWith.includes(familyList[idx])}
                        onChange={(e) => {
                          // If not in the list, add
                          if (
                            myChildLiveWith.indexOf(
                              familyList[e.target.value]
                            ) === -1
                          ) {
                            setMyChildLiveWith([
                              ...myChildLiveWith,
                              familyList[e.target.value],
                            ]);

                            // If in the list, remove
                          } else {
                            const foundIndex = myChildLiveWith.indexOf(
                              familyList[e.target.value]
                            );
                            const newLiveWith = myChildLiveWith;
                            newLiveWith.splice(foundIndex, 1);
                            setMyChildLiveWith([...newLiveWith]);
                          }
                        }}
                      />
                      <label
                        className="info-grid-choice"
                        htmlFor={"myChildLiveWith" + idx}
                        alt={item}
                      >
                        {item}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {fieldsList.includes("relationWithChild") && (
              <div className="question first-page">
                <b>귀하와 아동은 어떤 관계입니까?</b>
                <div className="red-dot" />
                <div className="info-grid">
                  {familyList.map((item, idx) => (
                    <div className="checkbox" key={keyCnt++}>
                      <input
                        id={"relationWithChild" + idx}
                        type="radio"
                        name="relationWithChild"
                        value={idx}
                        onChange={(e) =>
                          setRelationWithChild(familyList[e.target.value])
                        }
                        checked={relationWithChild === familyList[idx]}
                      />
                      <label
                        className="info-grid-choice"
                        htmlFor={"relationWithChild" + idx}
                        alt={item}
                      >
                        {item}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {fieldsList.includes("achievement") && (
              <div className="question first-page">
                <b>귀하의 학력에 표시해주십시오.</b>
                <div className="red-dot" />
                <div className="info-grid">
                  {educList.map((item, idx) => (
                    <div className="checkbox" key={keyCnt++}>
                      <input
                        id={"achievement" + idx}
                        type="radio"
                        name="achievement"
                        value={idx}
                        onChange={(e) =>
                          setAchievement(educList[e.target.value])
                        }
                        checked={achievement === educList[idx]}
                      />
                      <label
                        className="info-grid-choice"
                        htmlFor={"achievement" + idx}
                        alt={item}
                      >
                        {item}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {fieldsList.includes("jobType") && (
              <div className="question first-page">
                <b>귀하의 직업 유형에 표시해주십시오.</b>
                <div className="red-dot" />
                <div className="info-grid">
                  {jobList.map((item, idx) => (
                    <div className="checkbox" key={keyCnt++}>
                      <input
                        id={"jobType" + idx}
                        type="radio"
                        name="jobType"
                        value={idx}
                        onChange={(e) => setJobType(jobList[e.target.value])}
                        checked={jobType === jobList[idx]}
                      />
                      <label
                        className="info-grid-choice"
                        htmlFor={"jobType" + idx}
                        alt={item}
                      >
                        {item}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {fieldsList.includes("certificate") && (
              <div className="question first-page">
                <b>귀하께서 보유하신 아동관련 자격증은 무엇입니까?</b>
                <div className="red-dot" />
                <br />
                <b>(모두 표시해주세요. )</b>
                <div className="info-grid info-grid-long">
                  {certificateList.map((item, idx) => (
                    <div className="checkbox" key={keyCnt++}>
                      <input
                        id={"certificate" + idx}
                        type="checkbox"
                        name="certificate"
                        value={idx}
                        checked={certificate.includes(certificateList[idx])}
                        onChange={(e) => {
                          // If not in the list, add
                          if (
                            certificate.indexOf(
                              certificateList[e.target.value]
                            ) === -1
                          ) {
                            setCertificate([
                              ...certificate,
                              certificateList[e.target.value],
                            ]);

                            // If in the list, remove
                          } else {
                            const foundIndex = certificate.indexOf(
                              certificateList[e.target.value]
                            );
                            const newCertificate = certificate;
                            newCertificate.splice(foundIndex, 1);
                            setCertificate([...newCertificate]);
                          }
                        }}
                      />
                      <label
                        className="info-grid-choice"
                        htmlFor={"certificate" + idx}
                        alt={item}
                      >
                        {item}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {fieldsList.includes("isEducated") && (
              <div className="question first-page">
                <b>귀하는 아동인권 관련 교육을 받은 경험이 있습니까?</b>
                <div className="red-dot" />
                <br />
                <div className="radio">
                  {isEducatedList.map((item, idx) => (
                    <div className="info-radio-choice" key={keyCnt++}>
                      <input
                        id={"isEducated" + idx}
                        type="radio"
                        name="isEducated"
                        value={item.bool}
                        onChange={() => setIsEducated(item.bool)}
                        checked={isEducated === item.bool}
                      />
                      <label
                        className="isEducated"
                        htmlFor={"isEducated" + idx}
                        alt={item.str}
                      >
                        {item.str}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {fieldsList.includes("workedAt") && (
              <div className="question first-page">
                <b>당신은 어떤 유형의 기관 및 시설 소속인가요?</b>
                <div className="red-dot" />
                <div className="info-grid">
                  {workedAtList.map((item, idx) => (
                    <div className="checkbox" key={keyCnt++}>
                      <input
                        id={"workedAt" + idx}
                        type="radio"
                        name="workedAt"
                        value={idx}
                        onChange={(e) =>
                          setWorkedAt(workedAtList[e.target.value])
                        }
                        checked={workedAt === workedAtList[idx]}
                      />
                      <label
                        className="info-grid-choice"
                        htmlFor={"workedAt" + idx}
                        alt={item}
                      >
                        {item}
                      </label>
                    </div>
                  ))}
                  <div
                    style={{
                      gridColumnStart: 1,
                      gridColumnEnd: 3,
                      display: "flex",
                      alignItems: "center",
                      border: "1px solid #d0d7dd",
                      borderRadius: 5,
                      padding: "12px 16px",
                    }}
                  >
                    <span
                      style={{
                        whiteSpace: "pre",
                        fontSize: 12,
                        lineHeight: 1,
                        padding: "1px 0",
                        verticalAlign: "middle",
                        display: "inline-flex",
                        alignItems: "center",
                      }}
                    >
                      기타
                    </span>
                    <input
                      type="text"
                      style={{
                        width: "100%",
                        border: "none",
                        lineHeight: 1,
                        fontSize: 12,
                        display: "inline-flex",
                        alignItems: "center",
                        bottom: -0.5,
                        position: "relative",
                        padding: "0 8px",
                      }}
                      placeholder=""
                      onChange={(e) => setWorkedAt(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="link-buttons">
          <Link
            to={`/token/${token}/greeting`}
            className="link-btn"
            alt="뒤로 버튼"
          >
            뒤로
          </Link>
          <button className="link-btn" onClick={submit} alt="다음으로 버튼">
            다음으로
          </button>
        </div>
      </div>
    )
  );
};

export default InfoOne;
